import {initialData} from '@src/store/layout/misc'
import {LayoutState, Skin} from '@src/store/layout/type'
import {storageFactory} from '@src/utility/storageFactory'
import create from 'zustand'
import {persist} from 'zustand/middleware'

export const useLayoutStore = create<LayoutState>()(
  persist(
    (set, get) => ({
      ...initialData,
      getIsRTL: () => get().isRTL,
      getMenuCollapsed: () => get().menuCollapsed,
      getSkin: () => get().skin,
      reset: () => set({...initialData}),
      setIsRTL: (value: boolean) => set({isRTL: value}),
      setMenuCollapsed: (value: boolean) => set({menuCollapsed: value}),
      setSkin: (value: Skin) => set({skin: value})
    }),
    {
      getStorage: () => storageFactory(() => localStorage),
      name: 'layout-store',

      serialize: state => JSON.stringify(state),
      // eslint-disable-next-line sort-keys-fix/sort-keys-fix
      deserialize: str => (typeof str === 'string' ? JSON.parse(str) : null)
    }
  )
)
